<template>
  <section class="relative -mt-20 pt-20" ref="container">
    <div class="mt-8 p-4 container bg-white rounded">
      <header class="border-b pb-2 flex space-x-4 items-center">
        <h1 class="font-bold leading-6">Admin</h1>
      </header>
      <check-user />
    </div>
  </section>
</template>

<script>
import CheckUser from '../components/check-user.vue';

export default {
  name: 'admin-container',
  components: {
    CheckUser,
  },
};
</script>

<style scoped>
</style>
